import { objectToQueryString } from "../helpers/ApiHelper";
import { ICarePerformerRequest, ICarePerformerRequestResponse, ICarePerformerRequestSearchParams } from "../models/ICarePerformerRequest";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";

export class CarePerformerRequestApi extends ApiClient {

    createCarePerformerRequest(data: ICarePerformerRequest, success: (carePerformerRequestId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformerRequests`, data, success, error, final);
    }

    searchCarePerformerRequests(searchParams: ICarePerformerRequestSearchParams, success: (data: IPaginatedResponse<ICarePerformerRequestResponse>) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<ICarePerformerRequestResponse>(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformerRequests/searchCarePerformerRequests?${queryString}`, success, undefined, final);
    }

    getCarePerformerRequestById(carePerformerRequestId: number, success: (data: ICarePerformerRequest) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformerRequest>(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformerRequests/${carePerformerRequestId}`, success, error, final);
    }

    downloadCarePerformerRequestUploadedFile(carePerformerRequestId: number, carePerformerRequestUploadedFileId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.MEN_PORTAL_API_BASE_URL}/carePerformerRequests/${carePerformerRequestId}/carePerformerRequestUploadedFileId/${carePerformerRequestUploadedFileId}`, fileName ?? "", undefined, error);
    }
}
